import { Text } from '@/components/text';
import { TrafficLight } from '@/components/traffic-light';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { RouteModel } from '@/lib/models/route/types';
import { getDoesRouteTransitSuez } from '@/lib/models/route/utils/get-does-route-transit-suez';
import { formatDuration, formatFrequency } from '@/utils/format';
import { tv } from '@/utils/styles';

import { RouteTransitDurationPopout } from '../transit-duration-popout';

interface RouteTransitDurationIndicatorProps {
  route: RouteModel;
}

const RouteTransitDurationIndicator = ({ route }: RouteTransitDurationIndicatorProps) => {
  const { frequency, mainOptions, durationSeconds } = route;
  const suezTransitPossible = getDoesRouteTransitSuez(mainOptions);

  const { base, content, bg, primaryText, subText, textUnderline, alertWrapper } = styles();
  return (
    <div className={base()}>
      <span className={bg()} />
      <HoverCard openDelay={300}>
        <div className={content()}>
          <HoverCardTrigger>
            <Text className={primaryText()}>
              <span className={textUnderline()}>{formatDuration(durationSeconds)}</span>
            </Text>
            <Text className={subText()}>{frequency ? formatFrequency(frequency) : 'On demand'}</Text>
            {suezTransitPossible && (
              <div className={alertWrapper()}>
                <TrafficLight color="red" showAlertIcon />
              </div>
            )}
          </HoverCardTrigger>
          <HoverCardContent>
            <RouteTransitDurationPopout route={route} />
          </HoverCardContent>
        </div>
      </HoverCard>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'group/indicator relative',
    content: 'relative z-2 flex items-center leading-[14px]',
    bg: 'absolute -bottom-1.5 -left-2 -top-1.5 right-0 z-1 rounded-md group-hover/indicator:bg-grey-50',
    primaryText: 'm-0 block text-baseSm text-text-primary',
    subTextWrapper: 'mt-1.5 flex items-center',
    subText: 'mb-0 ml-0 mr-0 mt-1.5 overflow-hidden overflow-ellipsis whitespace-nowrap text-sm text-text-secondary',
    textUnderline:
      'relative after:absolute after:-bottom-0.5 after:left-0 after:right-0 after:border-b after:border-dashed after:border-grey-300 after:content-[""]',
    alertWrapper: 'absolute right-0 top-0 grid size-4 place-items-center',
  },
});

export { RouteTransitDurationIndicator };
